import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { User } from '@app/services/user/user';
import { Button } from '../button/button';
import { Image } from '../image/image';
import { Sso } from '@app/services/sso/sso';
import { APP_MENU } from '@app/config/menu';
import { RouterLink } from '@angular/router';
import { MenuItem } from '@app/models/menu';

@Component({
  selector: 'app-navbar',
  imports: [Button, Image, RouterLink],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css',
})
export class Navbar {
  private readonly UserService = inject(User);
  private readonly SSOService = inject(Sso);

  @ViewChild('mainContent') mainContent!: ElementRef;

  onNavigate() {
    setTimeout(() => {
      this.mainContent.nativeElement.focus();
    }, 0);
  }

  menu: MenuItem[] = [];

  ngOnInit() {
    this.filteredMenu();
    console.log('Filtered Menu:', this.menu); // Agrega este log para verificar el menú filtrado
  }

  // filter menu based on user roles
  filteredMenu() {
    const user = this.UserService.getUser();
    if (!user) return;
    this.menu = APP_MENU.filter((item) =>
      item.roles.some((role) => user.roles.includes(role)),
    );
  }

  get userEmail(): string | null {
    const user = this.UserService.getUser();
    return user ? user.email : null;
  }

  get userName(): string | null {
    const user = this.UserService.getUser();
    return user ? user.name : null;
  }

  handleLogout() {
    this.SSOService.logout();
  }

  isActive(route?: string): boolean {
    if (!route) return false;
    return window.location.pathname.includes(route.toLocaleLowerCase());
  }
}
